export var StatusEnum;
(function (StatusEnum) {
    StatusEnum["Draft"] = "draft";
    StatusEnum["Published"] = "published";
    StatusEnum["InternalUse"] = "internal-use";
    StatusEnum["Closed"] = "closed";
})(StatusEnum || (StatusEnum = {}));
//# sourceMappingURL=status.enum.js.map